import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdEmail, MdLockOutline } from "react-icons/md";
import { FaSignInAlt } from "react-icons/fa";
import Swal from "sweetalert2";
import "./ad.css";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://api.info-sight.net/admin/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        sessionStorage.setItem("isAdminLoggedIn", "true");
        sessionStorage.setItem("adminEmail", data.adminEmail);

        Swal.fire({
          title: "Login Successful",
          text: "Welcome, Admin!",
          icon: "success",
          confirmButtonText: "Continue",
          customClass: {
            popup: "swal-popup-success",
            title: "swal-title",
            confirmButton: "swal-confirm-button",
          },
        });

        navigate("/admin-dashboard");
      } else {
        setError(data.message);
        Swal.fire({
          title: "Login Failed",
          text: data.message,
          icon: "error",
          confirmButtonText: "Try Again",
          customClass: {
            popup: "swal-popup-error",
            title: "swal-title-error",
            confirmButton: "swal-confirm-button-error",
          },
        });
      }
    } catch (error) {
      setError("Unexpected error occurred!");

      Swal.fire({
        title: "Server Error",
        text: "Please try again later.",
        icon: "error",
        confirmButtonText: "Okay",
        customClass: {
          popup: "swal-popup-error",
          title: "swal-title-error",
          confirmButton: "swal-confirm-button-error",
        },
      });
    }
  };




  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        
        {/* LOGO */}
        <h1 style={styles.logo}>INFOSIGHT</h1>
        <p style={styles.tagline}>Engineering • AV • ICT • Security</p>

        {/* FORM */}
        <form onSubmit={handleLogin} style={styles.form}>
          
          <div style={styles.inputBox}>
            <MdEmail style={styles.icon} />
            <input
              type="email"
              placeholder="Admin Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={styles.input}
            />
          </div>

          <div style={styles.inputBox}>
            <MdLockOutline style={styles.icon} />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={styles.input}
            />
          </div>

          {error && <p style={styles.error}>{error}</p>}

          <button type="submit" style={styles.button}>
            <FaSignInAlt style={{ marginRight: 8 }} /> Login
          </button>
        </form>

        <p style={styles.footer}>© Infosight – Admin Access</p>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    minHeight: "100vh",
    background: "linear-gradient(145deg,#fbe8e8 10%,#fff 90%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
  },

  card: {
    background: "rgba(255,255,255,0.8)",
    backdropFilter: "blur(10px)",
    padding: "3rem 2.5rem",
    width: "100%",
    maxWidth: 420,
    borderRadius: 20,
    boxShadow: "0 15px 40px rgba(228, 6, 19, 0.2)",
    border: "1px solid rgba(228, 6, 19, 0.25)",
    textAlign: "center",
  },

  logo: {
    fontSize: "2.2rem",
    fontWeight: "900",
    color: "#e40613",
    letterSpacing: "1.5px",
  },

  tagline: {
    color: "#660309",
    fontSize: "0.9rem",
    marginTop: 4,
    marginBottom: "2rem",
    opacity: 0.8,
    fontWeight: "500",
  },

  form: {
    width: "100%",
  },

  inputBox: {
    position: "relative",
    marginBottom: "1.3rem",
    width: "100%",
  },

  icon: {
    position: "absolute",
    top: "13px",
    left: "14px",
    color: "#e40613",
    fontSize: "18px",
  },

  input: {
    width: "85%",
    padding: "12px 12px 12px 45px",
    borderRadius: 10,
    border: "1px solid #e40613",
    fontSize: "15px",
    background: "#ffffffcc",
    outline: "none",
    transition: "0.3s",
  },

  button: {
    width: "100%",
    padding: "12px",
    background: "#e40613",
    color: "#fff",
    border: "none",
    borderRadius: 10,
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    marginTop: "1rem",
    boxShadow: "0 6px 15px rgba(228,6,19,0.4)",
    transition: "0.25s",
  },

  error: {
    color: "#b30000",
    marginBottom: 8,
    fontSize: "0.9rem",
  },

  footer: {
    marginTop: "2rem",
    fontSize: "0.8rem",
    color: "#660309",
    opacity: 0.8,
  },
};

export default AdminLogin;
